<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        订单详情
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto;padding-bottom:100px" class="filtrate1">
      <div class="filtrate_head" v-show="show">
        <el-steps :active="plan" align-center finish-status="success">
          <el-step title="待付款"></el-step>
          <el-step title="待采购"></el-step>
          <el-step title="待发货" description></el-step>
          <el-step title="待收货" description></el-step>
          <el-step title="待评价" description></el-step>
          <el-step title="已完成" description></el-step>
          <el-step title="已取消" description></el-step>
        </el-steps>
      </div>
      <div class="filtrate_head" id="filtrate_head" v-show="show1">
        <i class="far fa-calendar-times fa-5x" id="fil_id"></i>
        <i class="fil_i">
          订单已取消
          <span style="color:rgb(246, 78, 98);">(原因:{{cancel_cause}})</span>
        </i>
      </div>
      <div style=" background:#fff; width: 1056px;margin: 0 auto;border:1px solid #ddd;">
        <div class="form-title">
          <div style="margin-left:10px;">
            <i class="fas fa-exclamation-circle"></i>
            当前订单状态:
            <span style="color:#F64E62">{{status}}</span>
          </div>
          <div>
            当前订单类型:
            <span style="color:#F64E62">{{order_type1}}</span>
          </div>
          <!-- <div style="margin-right:10px"> -->
            <!-- <el-row>
              <el-button
                v-if="status == '待收货'"
                size="small"
                @click="returnMOney(form.invoice_id)"
              >确定回款日期</el-button>
              <el-button size="small" @click="amend(form.invoice_id)">修改发票信息</el-button>
              <el-button
                size="small"
                @click="dialogFormVisible1 = true,consignee(),consignee_get(id)"
              >修改收货人信息</el-button>
              <el-button size="small" @click="dialogFormVisible2 = true">备注订单</el-button>
            </el-row> -->
          <!-- </div> -->
        </div>

        <div class="table">
          <template>
            <div style="display:flex;align-items:center; margin-top:40px;">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
              <p style="margin-left:6px;color:#333">基本信息</p>
            </div>
            <el-table border :data="tableData" style="width: 96%; margin:0 auto">
              <el-table-column prop="orderCode" align="center" label="订单编号" width="180"></el-table-column>
              <el-table-column prop="mobile" align="center" label="用户编号" width="180"></el-table-column>
              <el-table-column prop="pay_type" align="center" label="支付方式"></el-table-column>
              <el-table-column align="center" label="订单来源">PC</el-table-column>
              <el-table-column align="center" label="订单类型">普通</el-table-column>
              <el-table-column prop="express.express_code" align="center" label="物流单号"></el-table-column>
              <el-table-column prop="express.express_com" align="center" label="物流公司"></el-table-column>
              <el-table-column prop="coupons.coupons_id" align="center" label="优惠券信息"></el-table-column>
              <el-table-column align="center" label="备注" show-overflow-tooltip>
                <template slot-scope="scope">
                  <button
                    v-clipboard="scope.row.note"
                    v-clipboard:success="clickBoard"
                    style="cursor: pointer;overflow: hidden;width: 76px;border: none;color: #606266;background: #fff;outline: none;"
                  >{{ scope.row.note }}</button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="table">
          <template>
            <div style="display:flex;align-items:center; margin-top:40px;">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
              <p style="margin-left:6px;color:#333">发票信息</p>
            </div>
            <!-- 纸质发票/个人 -->
            <el-table v-show="invoice1" :data="tableData3" border style="width: 96%; margin:0 auto">
              <el-table-column align="center" prop="genre" label="发票类型"></el-table-column>

              <el-table-column prop="rise" align="center" label="发票抬头"></el-table-column>
              <el-table-column prop="name" align="center" label="名称"></el-table-column>

              <el-table-column width="170" prop="content" align="center" label="发票内容"></el-table-column>
              <el-table-column prop="invoice_name" align="center" label="收票人姓名"></el-table-column>
              <el-table-column width="170" prop="address" align="center" label="收票人地址"></el-table-column>
              <el-table-column prop="invoice_mobile" align="center" label="收票人电话"></el-table-column>
            </el-table>
            <!-- 纸质发票/单位 -->
            <el-table v-show="invoice2" :data="tableData3" border style="width: 96%; margin:0 auto">
              <el-table-column align="center" prop="genre" label="发票类型"></el-table-column>

              <el-table-column prop="rise" align="center" label="发票抬头"></el-table-column>
              <el-table-column prop="name" align="center" label="名称"></el-table-column>
              <el-table-column prop="tax_number" align="center" label="纳税人识别号"></el-table-column>

              <el-table-column prop="content" align="center" label="发票内容"></el-table-column>
              <el-table-column prop="invoice_name" align="center" label="收票人姓名"></el-table-column>
              <el-table-column prop="address" align="center" label="收票人地址"></el-table-column>
              <el-table-column prop="invoice_mobile" align="center" label="收票人电话"></el-table-column>
            </el-table>
            <!-- 增值税发票 -->
            <el-table v-show="invoice3" :data="tableData3" border style="width: 96%; margin:0 auto">
              <el-table-column width="100" prop="genre" align="center" label="发票类型"></el-table-column>
              <el-table-column prop="content" align="center" label="发票内容"></el-table-column>
              <el-table-column prop="name" align="center" label="单位名称"></el-table-column>
              <el-table-column prop="tax_number" align="center" label="纳税人识别号" width="110"></el-table-column>
              <el-table-column prop="register_address" align="center" label="注册地址"></el-table-column>
              <el-table-column prop="register_phone" align="center" label="注册电话"></el-table-column>
              <el-table-column prop="open_user_bank" align="center" label="开户银行"></el-table-column>
              <el-table-column prop="open_card_number" align="center" label="银行账户"></el-table-column>

              <el-table-column width="100" prop="invoice_name" align="center" label="收票人姓名"></el-table-column>
              <el-table-column width="100" prop="address" align="center" label="收票人地址"></el-table-column>
              <el-table-column width="120" prop="invoice_mobile" align="center" label="收票人电话"></el-table-column>
            </el-table>
          </template>
        </div>
        <div class="table">
          <template>
            <div style="display:flex;align-items:center; margin-top:40px;">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
              <p style="margin-left:6px;color:#333">收货人信息</p>
            </div>
            <el-table :data="tableData" border style="width: 96%; margin:0 auto">
              <el-table-column align="center" label="收货人" width="180">{{address_man}}</el-table-column>
              <el-table-column align="center" label="手机号码" width="180">{{address_tel}}</el-table-column>
              <el-table-column align="center" label="邮政编码"></el-table-column>
              <el-table-column
                align="center"
                label="收货人地址"
                width="400"
              >{{address}}{{address1}}{{address2}}{{address3}}</el-table-column>
            </el-table>
          </template>
        </div>
        <div class="table">
          <template>
            <div style="display:flex;align-items:center; margin-top:40px;">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
              <p style="margin-left:6px;color:#333">商品信息</p>
            </div>
            <el-table :data="tableData1" border style="width: 96%; margin:0 auto">
              <el-table-column align="center" label="商品图片" width="100">
                <template slot-scope="scope">
                  <img
                    :src="serve+'' +  scope.row.images"
                    alt
                    width="70px"
                    height="72px"
                  />
                </template>
              </el-table-column>
              <el-table-column align="center" prop="title" label="商品名称" width="200"></el-table-column>
              <el-table-column prop="item_no" align="center" label="货号" width="150"></el-table-column>
              <el-table-column align="center" label="价格" width="150">
                <template slot-scope="scope">
                  <i style="font-style:normal">￥</i>
                  {{scope.row.price}}
                </template>
              </el-table-column>
              <el-table-column prop="specification" align="center" label="属性" width="150"></el-table-column>
              <el-table-column prop="number" align="center" label="数量"></el-table-column>
              <el-table-column prop="inventory" align="center" label="库存"></el-table-column>
              <el-table-column align="center" label="小计">
                <template slot-scope="scope">{{scope.row.total}}</template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="table" style="margin-bottom:60px;position: relative;">
          <template>
            <div style="display:flex;align-items:center; margin-top:40px;">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
              <p style="margin-left:6px;color:#333">费用信息</p>
            </div>
            <el-table :data="tableData" border style="width: 96%; margin:0 auto">
              <el-table-column prop="all_money" align="center" label="商品合计" width="180"></el-table-column>
              <el-table-column prop="express_money" align="center" label="运费" width="180"></el-table-column>
              <el-table-column prop="coupons.name" align="center" label="优惠券"></el-table-column>

              <el-table-column prop="coupons.money" align="center" label="折扣金额"></el-table-column>

              <el-table-column prop="pay_money" align="center" label="应付款金额"></el-table-column>
              <el-table-column prop="pay_status" align="center" label="付款状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_status == '未付款'">{{scope.row.pay_status}}</span>
                  <span v-else>{{scope.row.pay_status}}/{{scope.row.payway}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="input_money" align="center" label="实付金额"></el-table-column>
            </el-table>
          </template>
          <!-- <el-button
            @click="showCanelOrder= true"
            v-show="showCancel"
            type="danger"
            style="position:absolute;right:290px;bottom:-50px;"
          >取消订单</el-button>
          <el-button
            @click="dialogFormVisible4= true"
            v-show="affirm"
            style="position:absolute;right:140px;bottom:-50px;"
          >修改订单金额</el-button>
          <el-button
            @click="dialogFormVisible3= true"
            v-show="affirm"
            style="position:absolute;right:20px;bottom:-50px;"
            type="success"
          >确认付款</el-button> -->
        </div>
        <div v-if="sellRemarkData.length > 0" class="sell_remark">
          <el-table :data="sellRemarkData" border style="width: 96%; margin:0 auto">
            <el-table-column prop="create_member" align="center" label="备注人" width="180"></el-table-column>
            <el-table-column prop="create_date" align="center" label="备注时间" width="180"></el-table-column>
            <el-table-column prop="remark" align="center" label="备注内容"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 点击修改发票信息/ 纸质发票/个人 -->
    <el-dialog :modal="false" title="修改发票信息" :visible.sync="dialog1" width="33%">
      <el-form :model="form">
        <el-form-item label="　发票类型:">
          <el-select @change="changeOption" style="width:356px" v-model="genre1111" :data="option">
            <el-option
              v-for="item in option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="　发票抬头:">
          <el-select
            @change="changeOption1"
            :disabled="disabled1111"
            style="width:356px"
            v-model="rise1111"
            :data="options"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="rise1111" style="width:356px" autocomplete="off"></el-input> -->
        </el-form-item>
        <el-form-item label="　　　名称:">
          <el-input v-model="name1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　发票内容:">
          <el-input v-model="content1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="收票人姓名:">
          <el-input v-model="invoice_name1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="收票人地址:">
          <el-input v-model="address1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收票人电话:">
          <el-input v-model="invoice_mobile1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="submntAmend()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 点击修改发票信息/ 纸质发票/单位 -->
    <el-dialog :modal="false" title="修改发票信息" :visible.sync="dialog2" width="33%">
      <el-form :model="form">
        <el-form-item label="　　发票类型:">
          <el-select @change="changeOption" style="width:356px" v-model="genre1111" :data="option">
            <el-option
              v-for="item in option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="　　发票抬头:">
          <el-select
            :disabled="disabled1111"
            @change="changeOption1"
            style="width:356px"
            v-model="rise1111"
            :data="options"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="rise1111" style="width:356px" autocomplete="off"></el-input> -->
        </el-form-item>
        <el-form-item label="　　　　名称:">
          <el-input v-model="name1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号:">
          <el-input v-model="tax_number1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="　　发票内容:">
          <el-input v-model="content1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="　收票人姓名:">
          <el-input v-model="invoice_name1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="　收票人地址:">
          <el-input v-model="address1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　收票人电话:">
          <el-input v-model="invoice_mobile1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog2 = false">取 消</el-button>
        <el-button type="primary" @click="submntAmend()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 点击修改发票信息/ 增值税发票 -->
    <el-dialog title="修改发票信息" :visible.sync="dialog3" width="33%" :modal="false">
      <el-form :model="form">
        <el-form-item label="　　发票类型:">
          <el-select @change="changeOption" style="width:356px" v-model="genre1111" :data="option">
            <el-option
              v-for="item in option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="　　发票内容:">
          <el-input v-model="content1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　　单位名称:">
          <el-input v-model="name1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号:">
          <el-input v-model="tax_number1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="　　注册地址:">
          <el-input v-model="register_address1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="　　注册电话:">
          <el-input v-model="register_phone1111" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="　　开户银行:">
          <el-input v-model="open_user_bank1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　　银行账户:">
          <el-input v-model="open_card_number1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　收票人姓名:">
          <el-input v-model="invoice_name1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　收票人地址:">
          <el-input v-model="address1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　收票人电话:">
          <el-input v-model="invoice_mobile1111" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog3 = false">取 消</el-button>
        <el-button type="primary" @click="submntAmend()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 点击修改收货人信息 -->
    <el-dialog title="修改收货人信息" :visible.sync="dialogFormVisible1" width="33%">
      <el-form :model="form">
        <el-form-item label="　　收货人:">
          <el-input v-model="name" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　手机号码:">
          <el-input v-model="mobile" style="width:356px"></el-input>
        </el-form-item>
        <el-form-item label="　邮政编码:">
          <el-input placeholder="暂无数据" style="width:356px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　所在区域:">
          <el-col :span="4" style="margin-right:4px;">
            <el-select v-model="province_value" placeholder="省" @change="handeladr1">
              <el-option
                v-for="item in province"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="5" style="margin-right:4px;">
            <el-select v-model="city_value" placeholder="市" @change="handeladr2">
              <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>

          <el-col :span="5">
            <el-select v-model="area_value" placeholder="区">
              <el-option v-for="item in area" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="　详细地址:">
          <textarea name id cols="47" rows="10" v-model="xiangxi "></textarea>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible1 = false,com_consignee()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 备注订单 -->
    <el-dialog title="备注订单" :visible.sync="dialogFormVisible2" width="33%">
      <el-form>
        <el-form-item label="操作备注:">
          <textarea name id cols="47" rows="10" v-model="close_remark"></textarea>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible2 = false,close()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="确定付款" :visible.sync="dialogFormVisible3" width="33%">
      <el-form>
        <el-form-item label="付款金额:">
          <el-input style="width:300px;" v-model="input_money1" placeholder="请输入付款金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="affirm1()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改订单金额" :visible.sync="dialogFormVisible4" width="33%">
      <el-form>
        <el-form-item label="订单金额:">
          <el-input style="width:300px;" v-model="input_money2" placeholder="请输入付款金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="affirm2()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="取消订单原因" :visible.sync="showCanelOrder" width="33%">
      <el-form>
        <el-form-item>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入备注信息"
            v-model="cancelCause"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCanelOrder = false">取 消</el-button>
        <el-button type="primary" @click="showCanelOrder = false,cancelOrder()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
   

<script>
// import $ from "jquery";
export default {
  name: "gallery",
  data() {
    return { serve: this.$store.state.serve,
      serve: this.$store.state.serve,
      showCanelOrder: false,
      cancel_cause: "",
      disabled1111: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      input_money1: "",
      input_money2: "",
      affirm: true,
      invoice1: true,
      invoice2: true,
      invoice3: true,
      show: true,
      show1: false,
      plan: null,
      close_remark: "",
      name: "",
      mobile: "",
      xiangxi: "",
      province: null,
      province_value: "",
      city: null,
      city_value: "",
      area: null,
      area_value: "",
      option: [
        {
          value: "1",
          label: "普通发票"
        },

        {
          value: "2",
          label: "增值税发票"
        }
      ],
      value: "",
      options: [
        {
          value: "2",
          label: "单位"
        },
        {
          value: "1",
          label: "个人"
        }
      ],
      values: "",
      form: {
        username: "",
        token: "",
        order_id: "",
        type: "",
        type1: "",
        head: "",
        content: "",
        invoice_mobile: "",
        invoice_email: "",
        invoice_id: ""
      },
      type: "",
      type1: "",
      address1111: "",
      content1111: "",
      genre1111: "",
      invoice_mobile1111: "",
      invoice_name1111: "",
      mobile1111: "",
      name1111: "",
      open_card_number1111: "",
      open_user_bank1111: "",
      register_address1111: "",
      register_phone1111: "",
      tax_number1111: "",
      rise1111: "",

      status: "",
      subtotal: "",
      address_tel: "",
      address_man: "",
      address: "",
      address1: "",
      address2: "",
      address3: "",
      orderCode: "",
      all_money: "",
      pay_money: "",
      mobile: "",
      pay_type: "",
      coupons: "",
      order_come: "PC",
      order_type: "普通",
      express_code: "",
      com_name: "",
      invoice: "",
      com_name: "",
      tableData: [],
      tableData1: [],
      tableData3: [],
      id: this.$route.params.id,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,

      order_type1: "",
      orderCode11: "",
      sellRemarkData: [],
      showCancel: true,
      cancelCause: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "商户列表";
    this.geting();
  },
  methods: {
    aleert_success(message) {
      this.$message({
        type: "success",
        message: message,
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        type: "error",
        message: message,
        offset: 200
      });
    },
    cancelOrder() {
      var where = {
        username: this.username,
        token: this.token,
        id: this.id,
        cancel_cause: this.cancelCause
      };
      this.axios
        .get(this.serve + "/admin/admin_cancel_order", {
          params: where
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.aleert_success("订单取消成功!");
            this.geting();
          } else {
            this.alert_error("订单取消失败!");
          }
        });
    },
    clickBoard() {
      this.$message({
        type: "success",
        message: "已复制到剪贴板",
        offset: 300
      });
    },
    returnMOney(v) {
      this.axios
        .get(this.serve+"/admin/payment_days_begin", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: this.orderCode11
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: res.data.msg
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    changeOption(v) {
      this.type = v;
      if (v == "2") {
        this.disabled1111 = true;
        this.dialog1 = false;
        this.dialog2 = false;
        this.dialog3 = true;
      } else if (v == "1") {
        this.dialog1 = true;
        this.dialog2 = false;
        this.dialog3 = false;
        this.disabled1111 = false;
      }
    },
    changeOption1(v) {
      this.type1 = v;
      if (v == "1") {
        this.dialog1 = true;
        this.dialog2 = false;
      }
      if (v == "2") {
        this.dialog1 = false;
        this.dialog2 = true;
      }
    },
    affirm2() {
      this.axios
        .get(this.serve+"/admin/change_order_money", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: this.orderCode11,
            money: this.input_money2
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.dialogFormVisible4 = false;
            this.geting();
            this.$message({
              type: "success",
              message: res.data.msg
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    affirm1() {
      this.axios
        .get(this.serve+"/admin/admin_pay", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: this.orderCode11,
            input_money: this.input_money1
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.dialogFormVisible3 = false;
            this.geting();
            this.$message({
              type: "success",
              message: "确认付款成功"
            });
          } else if (res.data.status == "error") {
            this.geting();
            this.$message.error("操作失败");
          }
        });
    },
    open2() {
      this.$message({
        message: "备注订单成功",
        type: "success"
      });
    },
    open4() {
      this.$message.error("备注失败");
    },
    close() {
      //备注订单
      const _this = this;
      this.axios
        .get(this.serve+"/admin/remark_order", {
          params: {
            username: this.username,
            token: this.token,
            order_id: this.id,
            remark: this.close_remark
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.open2();
          } else {
            this.open4();
          }
        });
    },
    com_consignee() {
      //确定修改收货人信息
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const _this = this;
      this.axios
        .get(this.serve+"/admin/change_address", {
          params: {
            username: this.username,
            token: this.token,
            order_id: this.id,
            name: this.name,
            mobile: this.mobile,
            province: this.province_value,
            city: this.city_value,
            area: this.area_value,
            address: this.xiangxi
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            this.geting();
          }
        })
        .catch(err => {
          alert("操作失败");
        });
    },
    handeladr1(name) {
      //点击一级列表
      this.consignee1(name);
    },
    handeladr2(name) {
      //点击二级列表
      this.consignee2(name);
    },
    consignee() {
      //点击修改收货人信息 三级联动
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/province", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          that.province = res.data;
          that.province_value = res.data.id;
        });
    },
    consignee1(name) {
      //二级列表
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/city?name=" + name)
        .then(res => {
          that.city = res.data;
          that.city_value = res.data.id;
        });
    },
    consignee2(name) {
      //三级列表
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/area?name=" + name)
        .then(res => {
          that.area = res.data;
          that.area_value = res.data.id;
        });
    },
    consignee_get(id) {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/order_info", {
          params: {
            username: this.username,
            token: this.token,
            order_id: id
          }
        })
        .then(res => {
          var json = res.data.data.address;
          var json_num = json.split(";");

          if (res.data.status == "success") {
            that.mobile = json_num[0];
            that.name = json_num[1];
            that.province_value = json_num[2];
            that.city_value = json_num[3];
            that.area_value = json_num[4];
            that.xiangxi = json_num[5];
          }
        });
    },
    amend(id) {
      //点击修改发票信息
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/get_invoice", {
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            this.type = json.type;
            this.type1 = json.type1;
            if (json.type === "1" && json.type1 === "1") {
              this.dialog1 = true;
              this.dialog2 = false;
              this.dialog3 = false;
              json.genre = "普通发票";
              json.rise = "个人";
              this.address1111 = json.address;
              this.genre1111 = json.genre;
              this.rise1111 = json.rise;
              this.name1111 = json.name;
              this.content1111 = json.content;
              this.invoice_name1111 = json.invoice_name;
              this.address1111 = json.address;
              this.invoice_mobile1111 = json.invoice_mobile;
            } else if (json.type === "2") {
              this.dialog1 = false;
              this.dialog2 = false;
              this.dialog3 = true;
              json.genre = "增值税发票";
              this.address1111 = json.address;
              this.content1111 = json.content;
              this.genre1111 = json.genre;
              this.invoice_mobile1111 = json.invoice_mobile;
              this.invoice_name1111 = json.invoice_name;
              this.mobile1111 = json.mobile;
              this.name1111 = json.name;
              this.open_card_number1111 = json.open_card_number;
              this.open_user_bank1111 = json.open_user_bank;
              this.register_address1111 = json.register_address;
              this.register_phone1111 = json.register_phone;
              this.tax_number1111 = json.tax_number;
            } else if (json.type === "1" && json.type1 === "2") {
              this.dialog1 = false;
              this.dialog2 = true;
              this.dialog3 = false;
              json.genre = "普通发票";
              json.rise = "单位";
              this.genre1111 = json.genre;
              this.rise1111 = json.rise;
              this.name1111 = json.name;
              this.tax_number1111 = json.tax_number;
              this.content1111 = json.content;
              this.invoice_name1111 = json.invoice_name;
              this.address1111 = json.address;
              this.invoice_mobile1111 = json.invoice_mobile;
            }
          }
        });
    },
    submntAmend() {
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/change_invoice", {
          params: {
            username: this.username,
            token: this.token,
            order_id: this.id,
            type: this.type,
            type1: this.type1,
            name: this.name1111,
            address: this.address1111,
            invoice_name: this.invoice_name1111,
            invoice_mobile: this.invoice_mobile1111,
            content: this.content1111,
            tax_number: this.tax_number1111,
            register_address: this.register_address1111,
            register_phone: this.register_phone1111,
            open_user_bank: this.open_user_bank1111,
            open_card_number: this.open_card_number1111
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            loading.close();
            this.geting();
            this.dialog1 = false;
            this.dialog2 = false;
            this.dialog3 = false;
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
            loading.close();
          }
        });
    },
    geting() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .get(this.serve+"/admin/order_info", {
          params: {
            username: this.username,
            token: this.token,
            order_id: this.id
          }
        })
        .then(res => {
          that.tableData3 = [];
          that.tableData1 = [];
          that.tableData = [];
          var json = res.data.data;
          that.order_type = json.order_type;
          that.sellRemarkData = json.sellRemark;
          if (json.order_type === "0") {
            that.order_type1 = "普通订单";
          } else if (json.order_type === "1") {
            that.order_type1 = "闲置交换";
          } else if (json.order_type === "2") {
            that.order_type1 = "积分商城";
          } else if (json.order_type === "3") {
            that.order_type1 = "抢购";
          } else if (json.order_type === "4") {
            that.order_type1 = "团购";
          }
          var plan_num = parseInt(json.status);
          that.plan = plan_num + 1;
          if (json.invoice.id) {
            that.form.invoice_id = json.invoice.id;

            if (json.invoice.type === "1" && json.invoice.type1 === "1") {
              that.invoice1 = true;
              that.invoice2 = false;
              that.invoice3 = false;
              json.invoice.genre = "普通发票";
              json.invoice.rise = "个人";
            } else if (json.invoice.type === "2") {
              that.invoice1 = false;
              that.invoice2 = false;
              that.invoice3 = true;
              json.invoice.genre = "增值税发票";
            } else if (
              json.invoice.type === "1" &&
              json.invoice.type1 === "2"
            ) {
              that.invoice1 = false;
              that.invoice2 = true;
              that.invoice3 = false;
              json.invoice.genre = "普通发票";
              json.invoice.rise = "单位";
            }
            that.tableData3.push(json.invoice);
          }
          if (json.invoice === "") {
            that.invoice1 = true;
            that.invoice2 = false;
            that.invoice3 = false;
          }
          if (json.status === "0") {
            that.status = "待付款";
          } else if (json.status === "1") {
            that.status = "待采购";
          } else if (json.status === "2") {
            that.status = "待发货";
          } else if (json.status === "3") {
            that.status = "待收货";
          } else if (json.status === "4") {
            that.status = "待评价";
          } else if (json.status === "5") {
            that.status = "已完成";
          } else if (json.status === "6") {
            that.status = "已取消";
            that.showCancel = false;
            that.show = false;
            that.show1 = true;
            that.cancel_cause = json.cancel_cause;
          }
          if (json.pay_type == "1") {
            json.pay_type = "在线支付";
          } else if (json.pay_type == "2") {
            json.pay_type = "账期支付";
          }
          if (json.pay_status == "0") {
            json.pay_status = "未付款";
            that.affirm = true;
          } else if (json.pay_status == "1") {
            json.pay_status = "已付款";
            that.affirm = false;
          }
          that.orderCode11 = json.orderCode;
          that.tableData.push(json);
          that.coupons =
            json.coupons.type + json.coupons.name + json.coupons.money;
          that.invoice = json.invoice;
          var addressRun = json.address.split(";");
          for (var key in addressRun) {
            that.address_tel = addressRun[0];
            that.address_man = addressRun[1];
            that.address = addressRun[2];
            that.address1 = addressRun[3];
            that.address2 = addressRun[4];
            that.address3 = addressRun[5];
          }
          for (var key in json.product_list) {
            that.subtotal =
              json.product_list[key].number *
              json.product_list[key].selling_price;
            that.tableData1.push(json.product_list[key]);
          }
          loading.close();
        });
    }
  }
};
</script>

<style lang="scss">
.sell_remark {
  padding-bottom: 50px;
  width: 100%;
  min-height: 200px;
}
.topBar {
  margin-bottom: 40px;
  .el-step__icon {
    height: 54px;
    width: 54px;
  }
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}

.filtrate1 {
  width: 1060px;
  // height: 100%;
  margin-left: 420px;
  // background: orange;el-table_1_column_1  is-center   is-leaf
  #filtrate_head {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    .fil_i {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin-top: 10px;
    }
    #fil_id {
      color: #999999;
    }
    // background: pink;

    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }

    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .form-title {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .fa-exclamation-circle {
      color: red;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }

    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}
.brand-page {
  background: #f5f5f5;
  color: #333;

  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }

  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>

